import React, { useEffect, useState } from "react";
import I from "../component/Icon";
import BC from "../component/Breadcrumb";
import apiService from "../services/apiService";
const showNotification = (type, message) => {
  if (
    typeof document === "undefined" ||
    typeof window === "undefined"
  ) {
    return;
  }
  const existingNotification =
    document.getElementById(
      "exam-form-notification"
    );
  if (existingNotification) {
    existingNotification.remove();
  }
  const notification =
    document.createElement("div");
  notification.id =
    "exam-form-notification";
  notification.textContent =
    `${type === "success" ? "✓" : "✕"} ${message}`;
  Object.assign(
    notification.style,
    {
      position: "fixed",
      top: "20px",
      right: "20px",
      zIndex: "99999",
      minWidth: "280px",
      maxWidth: "420px",
      padding: "12px 16px",
      borderRadius: "8px",
      backgroundColor:
        type === "success"
          ? "#d1e7dd"
          : "#f8d7da",
      color:
        type === "success"
          ? "#0f5132"
          : "#842029",
      border:
        type === "success"
          ? "1px solid #badbcc"
          : "1px solid #f5c2c7",
      fontSize: "14px",
      fontWeight: "600",
      boxShadow:
        "0 4px 12px rgba(0,0,0,0.15)",
    }
  );
  document.body.appendChild(
    notification
  );
  window.setTimeout(() => {
    if (notification.parentNode) {
      notification.remove();
    }
  }, 3000);
};
const getApiErrorMessage = (
  error,
  fallback
) => {
  const data =
    error?.response?.data;
  if (
    typeof data === "string" &&
    data.trim()
  ) {
    return data;
  }
  if (
    data &&
    typeof data === "object"
  ) {
    if (
      data?.errors &&
      typeof data.errors === "object"
    ) {
      const validationErrors =
        Object.values(data.errors)
          .flat()
          .filter(Boolean)
          .join(" ");
      if (validationErrors) {
        return validationErrors;
      }
    }
    return (
      data?.failureReason ||
      data?.FailureReason ||
      data?.message ||
      data?.Message ||
      data?.title ||
      data?.error ||
      error?.message ||
      fallback
    );
  }
  return (
    error?.message ||
    fallback
  );
};
export default function ExamForm({
  title,
  initial,
  onSave,
  onBack,
}) {
  const [f, setF] = useState({
    name:
      initial?.examName ??
      initial?.ExamName ??
      initial?.name ??
      "",
    exam:
      initial?.categoryId ??
      initial?.CategoryId ??
      initial?.exam ??
      "",
    type:
      initial?.examTypeId ??
      initial?.ExamTypeId ??
      initial?.type ??
      "",
    std:
      initial?.standardId ??
      initial?.StandardId ??
      initial?.std ??
      "",
    fees:
      initial?.examFee ??
      initial?.ExamFee ??
      initial?.fees ??
      "",
    date:
      (
        initial?.examDate ??
        initial?.ExamDate ??
        initial?.date ??
        ""
      )
        ? String(
          initial?.examDate ??
          initial?.ExamDate ??
          initial?.date
        ).split("T")[0]
        : "",
    startTime:
      (
        initial?.startTime ??
        initial?.StartTime ??
        ""
      )
        ? String(
          initial?.startTime ??
          initial?.StartTime
        ).slice(0, 5)
        : "",
    endTime:
      (
        initial?.endTime ??
        initial?.EndTime ??
        ""
      )
        ? String(
          initial?.endTime ??
          initial?.EndTime
        ).slice(0, 5)
        : "",
    teacher:
      initial?.teacherId ??
      initial?.TeacherId ??
      initial?.teacher ??
      "",
    maxStudents:
      initial?.maxStudents ??
      initial?.MaxStudents ??
      "",
    duration:
      initial?.durationMinutes ??
      initial?.DurationMinutes ??
      initial?.duration ??
      "",
    status:
      initial?.examStatus ??
      initial?.ExamStatus ??
      initial?.status ??
      "upcoming",
    resultDate:
      (
        initial?.resultDate ??
        initial?.ResultDate ??
        ""
      )
        ? String(
          initial?.resultDate ??
          initial?.ResultDate
        ).split("T")[0]
        : "",
    resultLink:
      initial?.resultLink ??
      initial?.ResultLink ??
      "",
    examImage:
      initial?.imageUrl ??
      initial?.ImageUrl ??
      initial?.imageURL ??
      initial?.ImageURL ??
      initial?.examImage ??
      initial?.ExamImage ??
      initial?.image ??
      initial?.Image ??
      "",
    description:
      initial?.description ??
      initial?.Description ??
      "",
  });
  const [addCatOpen, setAddCatOpen] = useState(false);
  const [addStdOpen, setAddStdOpen] = useState(false);
  const [newCat, setNewCat] = useState("");
  const [newStd, setNewStd] = useState("");
  const [categories, setCategories] = useState([]);
  const [categoryLoading, setCategoryLoading] = useState(false);
  const [categorySaving, setCategorySaving] = useState(false);
  // Standard Master API Data
  const [standards, setStandards] = useState([]);
  const [standardLoading, setStandardLoading] = useState(false);
  const [standardSaving, setStandardSaving] = useState(false);
  const [examTypes, setExamTypes] = useState([]);
  const [examTypesLoading, setExamTypesLoading] = useState(true);
  const [examTypesError, setExamTypesError] = useState("");
  useEffect(() => {
    let cancelled = false;
    const fetchExamTypes = async () => {
      try {
        const response = await apiService.get("ExamTypes/getAllExamTypes");
        const data = response.data;
        if (data?.isSuccess === false || data?.IsSuccess === false) {
          throw new Error(data?.failureReason || data?.FailureReason || "Failed to load Medium options");
        }
        const list = Array.isArray(data) ? data : data?.output ?? data?.Output;
        if (!Array.isArray(list)) throw new Error("Invalid Medium list response");
        if (!cancelled) {
          setExamTypes(list.filter((item) => item.isActive !== false && item.IsActive !== false));
        }
      } catch (error) {
        if (!cancelled) setExamTypesError(getApiErrorMessage(error, "Failed to load Medium options"));
      } finally {
        if (!cancelled) setExamTypesLoading(false);
      }
    };
    fetchExamTypes();
    return () => { cancelled = true; };
  }, []);
  const [fieldErrors, setFieldErrors] = useState({});
  const [examImagePreview, setExamImagePreview] = useState(
    initial?.imageUrl ??
    initial?.ImageUrl ??
    initial?.imageURL ??
    initial?.ImageURL ??
    initial?.examImage ??
    initial?.ExamImage ??
    initial?.image ??
    initial?.Image ??
    ""
  );
  const fetchCategories = async () => {
    try {
      setCategoryLoading(true);
      const response = await apiService.get(
        "ExamCategories/getAllExamCategories?includeInActive=true"
      );
      const data = response.data;
      if (
        data?.isSuccess === false ||
        data?.IsSuccess === false
      ) {
        throw new Error(
          data?.failureReason ??
          data?.FailureReason ??
          data?.message ??
          data?.Message ??
          "Failed to load categories"
        );
      }
      console.log("Category API Response:", data);
      const categoryList = Array.isArray(data)
        ? data
        : Array.isArray(data?.output)
          ? data.output
          : Array.isArray(data?.Output)
            ? data.Output
            : Array.isArray(data?.result)
              ? data.result
              : Array.isArray(data?.Result)
                ? data.Result
                : Array.isArray(data?.data)
                  ? data.data
                  : Array.isArray(data?.Data)
                    ? data.Data
                    : [];
      setCategories(categoryList);
      return categoryList;
    } catch (error) {
      console.error(
        "Get Category API Error:",
        error
      );
      setCategories([]);
      return [];
    } finally {
      setCategoryLoading(false);
    }
  };
  useEffect(() => {
    fetchCategories();
  }, []);
  const handleAddCategory = async () => {
    const categoryName =
      newCat.trim();
    if (!categoryName) {
      alert("Please enter category name");
      return;
    }
    try {
      setCategorySaving(true);
      const payload = {
        categoryName: categoryName,
        isActive: 1,
      };
      console.log(
        "Add Category Payload:",
        payload
      );
      const response = await apiService.post(
        "ExamCategories/addExamCategories",
        payload
      );
      const data = response.data;
      const output = data?.output ?? data?.Output;
      const outputStatus = output?.status ?? output?.Status ?? "";
      const outputMessage = output?.message ?? output?.Message ?? "";
      const statusText = String(outputStatus).toLowerCase();
      const messageText = String(outputMessage).toLowerCase();
      const isDuplicate =
        statusText.includes("duplicate") ||
        (messageText.includes("already") && messageText.includes("exist"));
      if (isDuplicate) {
        showNotification("error", outputMessage || "Category already exists.");
        return;
      }
      if (
        data?.isSuccess === false ||
        data?.IsSuccess === false
      ) {
        throw new Error(
          outputMessage ||
          data?.failureReason ||
          data?.FailureReason ||
          data?.message ||
          data?.Message ||
          "Failed to add category"
        );
      }
      const freshCategories =
        await fetchCategories();
      const addedCategory =
        freshCategories.find(
          (category) => {
            const name =
              category.categoryName ??
              category.CategoryName ??
              category.name ??
              category.Name;
            return (
              String(name)
                .trim()
                .toLowerCase() ===
              categoryName
                .trim()
                .toLowerCase()
            );
          }
        );
      const addedCategoryId =
        addedCategory?.id ??
        addedCategory?.Id ??
        addedCategory?.categoryId ??
        addedCategory?.CategoryId;
      if (addedCategoryId) {
        s(
          "exam",
          String(addedCategoryId)
        );
      }
      setNewCat("");
      setAddCatOpen(false);
    } catch (error) {
      console.error(
        "Add Category API Error:",
        error
      );
      alert(
        error.message ||
        "Failed to add category"
      );
    } finally {
      setCategorySaving(false);
    }
  };
  // ============================
  // GET STANDARD MASTER
  // ============================
  const fetchStandards = async () => {
    try {
      setStandardLoading(true);
      const response = await apiService.get(
        "StandardMaster/getAllStandardMasters?includeInActive=true"
      );
      const data = response.data;
      if (
        data?.isSuccess === false ||
        data?.IsSuccess === false
      ) {
        throw new Error(
          data?.failureReason ??
          data?.FailureReason ??
          data?.message ??
          data?.Message ??
          "Failed to load standards"
        );
      }
      const standardList = Array.isArray(data)
        ? data
        : Array.isArray(data?.output)
          ? data.output
          : Array.isArray(data?.Output)
            ? data.Output
            : Array.isArray(data?.result)
              ? data.result
              : Array.isArray(data?.Result)
                ? data.Result
                : Array.isArray(data?.data)
                  ? data.data
                  : Array.isArray(data?.Data)
                    ? data.Data
                    : [];
      setStandards(standardList);
      return standardList;
    } catch (error) {
      console.error(
        "Standard Master API Error:",
        error
      );
      setStandards([]);
      return [];
    } finally {
      setStandardLoading(false);
    }
  };
  useEffect(() => {
    fetchStandards();
  }, []);
  const handleAddStandard = async () => {
    const standardName = newStd.trim();
    if (!standardName) {
      alert("Please enter standard name");
      return;
    }
    try {
      setStandardSaving(true);
      const payload = {
        name: standardName,
        standardName: standardName,
        isActive: 1,
      };
      const response = await apiService.post(
        "StandardMaster/addStandardMaster",
        payload
      );
      const data = response.data;
      const output = data?.output ?? data?.Output;
      const outputStatus = output?.status ?? output?.Status ?? "";
      const outputMessage = output?.message ?? output?.Message ?? "";
      const statusText = String(outputStatus).toLowerCase();
      const messageText = String(outputMessage).toLowerCase();
      const isDuplicate =
        statusText.includes("duplicate") ||
        (messageText.includes("already") && messageText.includes("exist"));
      if (isDuplicate) {
        showNotification("error", outputMessage || "Standard already exists.");
        return;
      }
      if (
        data?.isSuccess === false ||
        data?.IsSuccess === false
      ) {
        throw new Error(
          outputMessage ||
          data?.failureReason ||
          data?.FailureReason ||
          data?.message ||
          data?.Message ||
          "Failed to add standard"
        );
      }
      const freshStandards =
        await fetchStandards();
      const addedStandard =
        freshStandards.find((standard) => {
          const name =
            standard.Name ??
            standard.StandardName ??
            standard.name ??
            standard.Name;
          return (
            String(name || "")
              .trim()
              .toLowerCase() ===
            standardName.toLowerCase()
          );
        });
      const addedStandardId =
        addedStandard?.standardId ??
        addedStandard?.StandardId ??
        addedStandard?.standardMasterId ??
        addedStandard?.StandardMasterId ??
        addedStandard?.id ??
        addedStandard?.Id;
      if (addedStandardId) {
        s(
          "std",
          String(addedStandardId)
        );
      }
      setNewStd("");
      setAddStdOpen(false);
      showNotification(
        "success",
        data?.message ||
        data?.Message ||
        "Standard added successfully!"
      );
    } catch (error) {
      console.error(
        "Add Standard API Error:",
        error
      );
      showNotification(
        "error",
        getApiErrorMessage(
          error,
          "Failed to add standard"
        )
      );
    } finally {
      setStandardSaving(false);
    }
  };
  useEffect(() => {
    const existingImage =
      initial?.imageUrl ??
      initial?.ImageUrl ??
      initial?.imageURL ??
      initial?.ImageURL ??
      initial?.examImage ??
      initial?.ExamImage ??
      initial?.image ??
      initial?.Image ??
      initial?.examImageUrl ??
      initial?.ExamImageUrl ??
      "";
    setExamImagePreview(existingImage);
    setF((prev) => ({
      ...prev,
      examImage: existingImage,
    }));
  }, [
    initial?.imageUrl,
    initial?.ImageUrl,
    initial?.imageURL,
    initial?.ImageURL,
    initial?.examImage,
    initial?.ExamImage,
    initial?.image,
    initial?.Image,
    initial?.examImageUrl,
    initial?.ExamImageUrl,
  ]);
  useEffect(() => {
    const existingResultDate =
      initial?.resultDate ??
      initial?.ResultDate ??
      "";
    const existingResultLink =
      initial?.resultLink ??
      initial?.ResultLink ??
      "";
    setF((prev) => ({
      ...prev,
      resultDate: existingResultDate
        ? String(existingResultDate).split("T")[0]
        : "",
      resultLink: existingResultLink,
    }));
  }, [
    initial?.resultDate,
    initial?.ResultDate,
    initial?.resultLink,
    initial?.ResultLink,
  ]);
  const calculateDuration = (startTime, endTime) => {
    if (!startTime || !endTime) return "";
    const [startHour, startMinute] = startTime
      .split(":")
      .map(Number);
    const [endHour, endMinute] = endTime
      .split(":")
      .map(Number);
    const startTotal =
      startHour * 60 + startMinute;
    const endTotal =
      endHour * 60 + endMinute;
    if (endTotal <= startTotal) {
      return "";
    }
    return endTotal - startTotal;
  };
  const getTodayDate = () => {
    const today = new Date();
    const year = today.getFullYear();
    const month = String(
      today.getMonth() + 1
    ).padStart(2, "0");
    const day = String(
      today.getDate()
    ).padStart(2, "0");
    return `${year}-${month}-${day}`;
  };
  const getExamImageSrc = (value) => {
    if (!value) return "";
    if (
      value.startsWith("http://") ||
      value.startsWith("https://") ||
      value.startsWith("data:")
    ) {
      return value;
    }
    return `https://goreeduhub.cloud${value.startsWith("/") ? "" : "/"
      }${value}`;
  };
  const handleExamImageChange = (event) => {
    const file = event.target.files?.[0];
    if (!file) {
      s("examImage", "");
      setExamImagePreview("");
      return;
    }
    if (!file.type.startsWith("image/")) {
      showNotification(
        "error",
        "Please select an image file."
      );
      event.target.value = "";
      return;
    }
    if (file.size > 2 * 1024 * 1024) {
      showNotification(
        "error",
        "Exam image must be 2 MB or less."
      );
      event.target.value = "";
      return;
    }
    const reader = new FileReader();
    reader.onloadend = () => {
      const imageData = reader.result;
      s("examImage", imageData);
      setExamImagePreview(imageData);
    };
    reader.readAsDataURL(file);
  };
  const s = (k, v) => {
    setF((p) => ({
      ...p,
      [k]: v,
    }));
    setFieldErrors((prev) => {
      const updated = { ...prev };
      delete updated[k];
      return updated;
    });
  };
  const validateForm = () => {
    const e = {};
    if (!String(f.name || "").trim()) {
      e.name = "Exam name is required";
    }
    if (!f.exam) {
      e.exam = "Category is required";
    }
    if (!f.std) {
      e.std = "Standard is required";
    }
    if (
      f.fees === "" ||
      f.fees === null ||
      f.fees === undefined
    ) {
      e.fees = "Fees is required";
    }
    if (!f.date) {
      e.date = "Exam date is required";
    }
    if (!f.startTime) {
      e.startTime = "Start time is required";
    }
    if (!f.endTime) {
      e.endTime = "End time is required";
    }
    if (!f.duration) {
      e.duration = "Duration is required";
    }
    if (!Number.isInteger(Number(f.type)) || Number(f.type) <= 0) {
      e.type = "Please select a valid Medium";
    }
    if (!f.status) {
      e.status = "Status is required";
    }
    if (!f.resultDate) {
      e.resultDate = "Result date is required";
    }
    if (!String(f.resultLink || "").trim()) {
      e.resultLink = "Result link is required";
    } else {
      try {
        const parsedResultUrl = new URL(
          String(f.resultLink).trim()
        );
        if (
          parsedResultUrl.protocol !== "http:" &&
          parsedResultUrl.protocol !== "https:"
        ) {
          e.resultLink = "Enter a valid result link";
        }
      } catch {
        e.resultLink = "Enter a valid result link";
      }
    }
    return e;
  };
  const handleSave = async () => {
    const validationErrors = validateForm();
    if (Object.keys(validationErrors).length > 0) {
      setFieldErrors(validationErrors);
      showNotification(
        "error",
        Object.values(validationErrors)[0] ||
        "Please fill all required fields."
      );
      return;
    }
    setFieldErrors({});
    const isEdit = Boolean(
      initial?.id ??
      initial?.Id
    );
    const examId =
      initial?.id ??
      initial?.Id ??
      0;
    const payload = {
      ...(isEdit
        ? {
          id: Number(examId),
        }
        : {}),
      examName: f.name,
      categoryId:
        Number(f.exam) || 0,
      examTypeId: Number(f.type) || 0,
      standardId:
        Number(f.std) || 0,
      examDate:
        f.date || null,
      startTime:
        f.startTime || "00:00",
      endTime:
        f.endTime || "00:00",
      durationMinutes:
        Number(f.duration) || 0,
      teacherId: Number(f.teacher) || 0,
      centerId: 0,
      maxStudents: Number(f.maxStudents) || 0,
      examStatus:
        f.status,
      resultDate:
        f.resultDate || null,
      resultLink:
        f.resultLink?.trim() || "",
      imageUrl:
        f.examImage || "",
      description:
        f.description || "",
      examFee:
        Number(f.fees) || 0,
      ...(isEdit
        ? {
          isActive: Number(
            initial?.isActive ??
            initial?.IsActive ??
            1
          ),
        }
        : {}),
    };
    console.log(
      isEdit
        ? "Update Exam Payload:"
        : "Exam Payload:",
      payload
    );
    console.log(
      "Exam Payload JSON:",
      JSON.stringify(payload, null, 2)
    );
    try {
      const response = isEdit
        ? await apiService.put(
          "Exam/updateExam",
          payload
        )
        : await apiService.post(
          "Exam/addExam",
          payload
        );
      const data = response.data;
      console.log(
        isEdit
          ? "Update Exam Response:"
          : "Add Exam Response:",
        data
      );
      const output =
        data?.output ??
        data?.Output;
      const outputStatus =
        output?.status ??
        output?.Status ??
        "";
      const outputMessage =
        output?.message ??
        output?.Message ??
        "";
      const statusText =
        String(outputStatus)
          .toLowerCase();
      const messageText =
        String(outputMessage)
          .toLowerCase();
      const isDuplicate =
        statusText.includes("duplicate") ||
        (
          messageText.includes("already") &&
          messageText.includes("exist")
        );
      if (isDuplicate) {
        showNotification(
          "error",
          outputMessage ||
          "Exam already exists."
        );
        return;
      }
      if (
        data?.isSuccess === false ||
        data?.IsSuccess === false
      ) {
        throw new Error(
          outputMessage ||
          data?.failureReason ||
          data?.FailureReason ||
          data?.message ||
          data?.Message ||
          (
            isEdit
              ? "Exam update failed"
              : "Exam save failed"
          )
        );
      }
      showNotification(
        "success",
        data?.message ||
        data?.Message ||
        (
          isEdit
            ? "Exam updated successfully!"
            : "Exam created successfully!"
        )
      );
      const selectedCategory =
        categories.find(
          (category) => {
            const categoryId =
              category.id ??
              category.Id ??
              category.categoryId ??
              category.CategoryId;
            return (
              String(categoryId) ===
              String(f.exam)
            );
          }
        );
      const selectedCategoryName =
        selectedCategory?.categoryName ??
        selectedCategory?.CategoryName ??
        selectedCategory?.name ??
        selectedCategory?.Name ??
        f.exam;
      if (onSave) {
        onSave({
          ...f,
          id:
            isEdit
              ? Number(examId)
              : initial?.id,
          categoryId:
            Number(f.exam) || 0,
          categoryName:
            selectedCategoryName,
          exam:
            selectedCategoryName,
          examTypeId:
            f.type
              ? Number(f.type)
              : null,
          standardId:
            Number(f.std) || 0,
          teacherId:
            f.teacher
              ? Number(f.teacher)
              : null,
          centerId: 0,
          maxStudents:
            f.maxStudents
              ? Number(f.maxStudents)
              : null,
          resultDate:
            f.resultDate || null,
          resultLink:
            f.resultLink?.trim() || "",
          imageUrl:
            f.examImage || "",
          isActive:
            isEdit
              ? Number(
                initial?.isActive ??
                initial?.IsActive ??
                1
              )
              : 1,
        });
      }
      if (onBack) {
        onBack();
      }
    } catch (error) {
      console.error(
        isEdit
          ? "Update Exam API Error:"
          : "Add Exam API Error:",
        error
      );
      console.log(
        "Exam API Error Response:",
        JSON.stringify(
          error?.response?.data,
          null,
          2
        )
      );
      console.log(
        "Exam API Status:",
        error?.response?.status
      );
      console.log(
        "Exam API Headers:",
        error?.response?.headers
      );
      console.log(
        "Sent Payload:",
        JSON.stringify(
          payload,
          null,
          2
        )
      );
      showNotification(
        "error",
        getApiErrorMessage(
          error,
          isEdit
            ? "Exam update failed"
            : "Exam save failed"
        )
      );
    }
  };
  const renderFieldError = (name) => {
    if (!fieldErrors?.[name]) return null;
    return (
      <div
        style={{
          color: "#dc2626",
          fontSize: 10.5,
          marginTop: 4,
        }}
      >
        {fieldErrors[name]}
      </div>
    );
  };
  return (
    <>
      <BC
        items={[
          "Exams",
          title,
        ]}
        onBack={onBack}
      />
      <div
        className="card cp"
        style={{
          maxWidth: 680,
        }}
      >
        <div
          style={{
            fontWeight: 700,
            fontSize: 15,
            marginBottom: 18,
          }}
        >
          {title}
        </div>
        <div className="fgrid">
          {/* Exam Name */}
          <div className="fg fall">
            <label className="fl">
              Exam Name *
            </label>
            <input
              className="fi"
              value={f.name}
              onChange={(e) =>
                s(
                  "name",
                  e.target.value
                )
              }
              placeholder="e.g. State Level Olympiad 2025"
            />
            {renderFieldError("name")}
          </div>
          {/* Exam Image */}
          <div className="fg">
            <label className="fl">
              Exam Image
            </label>
            <input
              className="fi"
              type="file"
              accept="image/*"
              onChange={handleExamImageChange}
            />
            {examImagePreview && (
              <img
                src={getExamImageSrc(examImagePreview)}
                alt="Exam Preview"
                style={{
                  width: "100%",
                  maxWidth: "180px",
                  height: "110px",
                  objectFit: "cover",
                  borderRadius: "8px",
                  marginTop: "8px",
                  border: "1px solid #e2e8f0",
                }}
              />
            )}
          </div>
          {/* Category */}
          <div className="fg">
            <label className="fl">
              Category *
            </label>
            <select
              className="fi"
              value={f.exam}
              onChange={(e) => {
                if (
                  e.target.value === "__add__"
                ) {
                  setAddCatOpen(true);
                } else {
                  s(
                    "exam",
                    e.target.value
                  );
                }
              }}
            >
              <option value="">
                {categoryLoading
                  ? "Loading Categories..."
                  : "Select…"}
              </option>
              {categories.map((category) => {
                const categoryId =
                  category.id ??
                  category.Id ??
                  category.categoryId ??
                  category.CategoryId;
                const categoryName =
                  category.categoryName ??
                  category.CategoryName ??
                  category.name ??
                  category.Name;
                return (
                  <option
                    key={categoryId ?? categoryName}
                    value={categoryId}
                  >
                    {categoryName}
                  </option>
                );
              })}
              <option
                value="__add__"
                style={{
                  color: "#2563EB",
                  fontWeight: 600,
                }}
              >
                ＋ Add New Category
              </option>
            </select>
            {renderFieldError("exam")}
          </div>
          {/* Standard */}
          <div className="fg">
            <label className="fl">
              Std *
            </label>
            <select
              className="fi"
              value={f.std}
              onChange={(e) => {
                if (
                  e.target.value === "__add_std__"
                ) {
                  setAddStdOpen(true);
                } else {
                  s(
                    "std",
                    e.target.value
                  );
                }
              }}
            >
              <option value="">
                {standardLoading
                  ? "Loading Standards..."
                  : "Select Standard…"}
              </option>
              {standards.map(
                (standard) => {
                  const standardId =
                    standard.standardId ??
                    standard.StandardId ??
                    standard.standardMasterId ??
                    standard.StandardMasterId ??
                    standard.id ??
                    standard.Id;
                  const standardName =
                    standard.standardName ??
                    standard.StandardName ??
                    standard.name ??
                    standard.Name ??
                    standard.standard ??
                    standard.Standard ??
                    standard.displayName ??
                    standard.DisplayName ??
                    standardId;
                  return (
                    <option
                      key={standardId}
                      value={standardId}
                    >
                      {standardName}
                    </option>
                  );
                }
              )}
              <option
                value="__add_std__"
                style={{
                  color: "#2563EB",
                  fontWeight: 600,
                }}
              >
                ＋ Add New Standard
              </option>
            </select>
            {renderFieldError("std")}
          </div>
          <div className="fg">
            <label className="fl" htmlFor="exam-medium">Medium *</label>
            <select
              disabled={examTypesLoading}
              id="exam-medium"
              className="fi"
              value={f.type}
              onChange={(e) => s("type", e.target.value)}
            >
              <option value="">{examTypesLoading ? "Loading Medium..." : "Select Medium…"}</option>
              {examTypes.map((examType) => {
                const id = examType.examTypeId ?? examType.ExamTypeId ?? examType.id ?? examType.Id;
                if (!Number.isInteger(Number(id)) || Number(id) <= 0) return null;
                return <option key={id} value={id}>{examType.typeName ?? examType.TypeName ?? "Medium"} </option>;
              })}
            </select>
            {examTypesError && <div role="alert" style={{ color: "#dc2626", marginTop: 4 }}>{examTypesError}</div>}
            {!examTypesLoading && !examTypesError && examTypes.length === 0 && <div role="status">No Medium options available.</div>}
            {renderFieldError("type")}
          </div>
          {/* Fees */}
          <div className="fg">
            <label className="fl">
              Fees
            </label>
            <input
              className="fi"
              type="text"
              inputMode="numeric"
              value={f.fees}
              onChange={(e) =>
                s(
                  "fees",
                  e.target.value.replace(
                    /\D/g,
                    ""
                  )
                )
              }
              placeholder="e.g. 500"
            />
            {renderFieldError("fees")}
          </div>
          {/* Date */}
          <div className="fg">
            <label className="fl">
              Exam Date *
            </label>
            <input
              className="fi"
              type="date"
              value={f.date}
              onChange={(e) =>
                s(
                  "date",
                  e.target.value
                )
              }
            />
            {renderFieldError("date")}
          </div>
          {/* Start Time */}
          <div className="fg">
            <label className="fl">
              Exam Start Time *
            </label>
            <input
              className="fi"
              type="time"
              value={f.startTime}
              onChange={(e) => {
                const startTime = e.target.value;
                setF((prev) => ({
                  ...prev,
                  startTime,
                  duration: calculateDuration(
                    startTime,
                    prev.endTime
                  ),
                }));
              }}
            />
            {renderFieldError("startTime")}
          </div>
          {/* End Time */}
          <div className="fg">
            <label className="fl">
              Exam End Time *
            </label>
            <input
              className="fi"
              type="time"
              value={f.endTime}
              onChange={(e) => {
                const endTime = e.target.value;
                setF((prev) => ({
                  ...prev,
                  endTime,
                  duration: calculateDuration(
                    prev.startTime,
                    endTime
                  ),
                }));
              }}
            />
            {renderFieldError("endTime")}
          </div>
          {/* Duration */}
          <div className="fg">
            <label className="fl">
              Duration (min)
            </label>
            <input
              className="fi"
              type="number"
              value={f.duration}
              readOnly
              placeholder="Auto calculated"
            />
            {renderFieldError("duration")}
          </div>
          {/* Status */}
          <div className="fg">
            <label className="fl">
              Status
            </label>
            <select
              className="fi"
              value={f.status}
              onChange={(e) =>
                s(
                  "status",
                  e.target.value
                )
              }
            >
              <option value="upcoming">
                Upcoming
              </option>
              <option value="active">
                Active
              </option>
              <option value="completed">
                Completed
              </option>
            </select>
            {renderFieldError("status")}
          </div>
          {/* Result Date */}
          <div className="fg">
            <label className="fl">
              Result Date *
            </label>
            <input
              className="fi"
              type="date"
              value={f.resultDate}
              onChange={(e) =>
                s(
                  "resultDate",
                  e.target.value
                )
              }
            />
            {renderFieldError(
              "resultDate"
            )}
          </div>
          {/* Result Link */}
          <div className="fg">
            <label className="fl">
              Result Link *
            </label>
            <input
              className="fi"
              type="url"
              value={f.resultLink}
              onChange={(e) =>
                s(
                  "resultLink",
                  e.target.value
                )
              }
              placeholder="https://example.com/result"
            />
            {renderFieldError("resultLink")}
          </div>
          {/* Description */}
          <div className="fg fall">
            <label className="fl">
              Description
            </label>
            <textarea
              className="ta"
              value={
                f.description
              }
              onChange={(e) =>
                s(
                  "description",
                  e.target.value
                )
              }
              placeholder="Enter exam description..."
            />
          </div>
        </div>
        {/* Buttons */}
        <div
          style={{
            display: "flex",
            gap: 9,
            marginTop: 18,
          }}
        >
          <button
            className="btn btn-p"
            onClick={handleSave}
          >
            <I
              n="check"
              s={13}
              c="#fff"
            />
            {initial
              ? "Update"
              : "Create Exam"}
          </button>
          <button
            className="btn btn-g"
            onClick={onBack}
          >
            Cancel
          </button>
        </div>
      </div>
      {/* Add Category Modal */}
      {addCatOpen && (
        <div
          className="modal-bg"
          onClick={() =>
            setAddCatOpen(false)
          }
        >
          <div
            className="modal modal-sm"
            onClick={(e) =>
              e.stopPropagation()
            }
          >
            <div className="mhdr">
              <div className="mhdr-t">
                Add New Category
              </div>
              <button
                className="xbtn"
                onClick={() =>
                  setAddCatOpen(false)
                }
              >
                <I
                  n="x"
                  s={13}
                />
              </button>
            </div>
            <div className="mbody">
              <div className="fg">
                <label className="fl">
                  Category Name
                </label>
                <input
                  className="fi"
                  value={newCat}
                  onChange={(e) =>
                    setNewCat(
                      e.target.value
                    )
                  }
                  placeholder="e.g. Sparsh"
                  autoFocus
                />
              </div>
            </div>
            <div className="mfoot">
              <button
                className="btn btn-g"
                onClick={() =>
                  setAddCatOpen(false)
                }
              >
                Cancel
              </button>
              <button
                className="btn btn-p"
                onClick={handleAddCategory}
                disabled={categorySaving}
              >
                <I
                  n="check"
                  s={13}
                  c="#fff"
                />
                {categorySaving
                  ? "Adding..."
                  : "Add"}
              </button>
            </div>
          </div>
        </div>
      )}
      {/* Add Standard Modal */}
      {addStdOpen && (
        <div
          className="modal-bg"
          onClick={() =>
            setAddStdOpen(false)
          }
        >
          <div
            className="modal modal-sm"
            onClick={(e) =>
              e.stopPropagation()
            }
          >
            <div className="mhdr">
              <div className="mhdr-t">
                Add New Standard
              </div>
              <button
                className="xbtn"
                onClick={() =>
                  setAddStdOpen(false)
                }
              >
                <I n="x" s={13} />
              </button>
            </div>
            <div className="mbody">
              <div className="fg">
                <label className="fl">
                  Standard Name
                </label>
                <input
                  className="fi"
                  value={newStd}
                  onChange={(e) =>
                    setNewStd(
                      e.target.value
                    )
                  }
                  placeholder="e.g. 5th Standard"
                  autoFocus
                />
              </div>
            </div>
            <div className="mfoot">
              <button
                className="btn btn-g"
                onClick={() =>
                  setAddStdOpen(false)
                }
              >
                Cancel
              </button>
              <button
                className="btn btn-p"
                onClick={handleAddStandard}
                disabled={standardSaving}
              >
                <I
                  n="check"
                  s={13}
                  c="#fff"
                />
                {standardSaving
                  ? "Adding..."
                  : "Add"}
              </button>
            </div>
          </div>
        </div>
      )}
    </>
  );
}
